import { clearAuthToken } from "../jwtAuth";

export const clearAppData = async () => {
  try {
    clearAuthToken();
    // Clear storage
    localStorage.clear();
    sessionStorage.clear();

    // Clear cookies (same-origin)
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
    });

    // Clear caches (PWA / SW)
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }

    console.log("App data cleared");
  } catch (err) {
    console.warn("Failed to clear app data", err);
  }
};
